import { PUBLIC_DIFFUSION_API_ENDPOINT } from '$env/static/public';
import { delay } from '$lib/delay';
import {
	Client as DiffusionApiClient,
	type GeneratedImage,
	type GeneratedImagePatch,
	type GetGeneratedImagesResponse
} from '$lib/diffusionApi';

export class GeneratedImagesClient {
	private diffusionApiClient: DiffusionApiClient;

	constructor(token: string) {
		this.diffusionApiClient = new DiffusionApiClient({
			BASE: PUBLIC_DIFFUSION_API_ENDPOINT,
			TOKEN: token
		});
	}

	public setToken(token: string) {
		this.diffusionApiClient = new DiffusionApiClient({
			BASE: PUBLIC_DIFFUSION_API_ENDPOINT,
			TOKEN: token
		});
	}

	public async getGeneratedImages(
		userId: string,
		saved: boolean,
		config?: {
			skip?: number;
			limit?: number;
			most_recent_first?: boolean;
			generation_ids?: string[];
			journey_id?: string;
		}
	): Promise<GetGeneratedImagesResponse> {
		return await this.diffusionApiClient.default.getGeneratedImagesGeneratedImagesGet(
			userId,
			saved,
			config?.skip,
			config?.limit,
			config?.most_recent_first,
			config?.generation_ids,
			config?.journey_id
		);
	}

	public async patchGeneratedImages(patches: GeneratedImagePatch[]) {
		try {
			const response =
				await this.diffusionApiClient.default.patchGeneratedImagesGeneratedImagesPatch({
					patches
				});
			return response;
		} catch (error) {
			console.error(error);
			return undefined;
		}
	}
}
